import { useAnalyticsContext } from '@hubtype/data-access-analytics'

import { SaveOrigin, TrackEventName } from '../../../analytics-events'
import { postCloseFromFlowBuilderMessage } from '../../../hubtype-events'
import { useRealtimeContext } from '../../../realtime'
import { useFlowBuilderSelector } from '../../../reducer/hooks'
import { LoadingMessage } from '../../../types'
import { useSave } from '../save/use-save'

export const useExit = () => {
  const analytics = useAnalyticsContext()
  const { saveFlow } = useSave()
  const realtimeClient = useRealtimeContext()
  const { state, setLoadingMessage } = useFlowBuilderSelector(ctx => ctx)

  const exitFlow = async (closeData?: string): Promise<void> => {
    realtimeClient.close()
    await analytics.trackEvent(TrackEventName.Exit, {
      origin: closeData ? 'nav_bar' : 'exit',
    })
    if (!state.isFlowSaved) {
      setLoadingMessage(LoadingMessage.Save)
      await saveFlow(SaveOrigin.ON_EXIT)
      setLoadingMessage(undefined)
    }
    postCloseFromFlowBuilderMessage(closeData || null)
  }

  return { exitFlow }
}
